import { useMutation } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export type UpdateRequestConfigParams = {
  requestId: string
  blockId: string
  updateRequest: boolean
  updateRequestStep: boolean
}

const callUpdateBlockConfigApi = async (token: string, params: UpdateRequestConfigParams): Promise<void> => {
  const apiClient = new RequestsHttpClient({ authorization: token })
  const { requestId, blockId, updateRequest, updateRequestStep } = params
  const { error } = await apiClient.POST('/{id}/blocks/{blockId}/update-block-config', {
    params: { path: { id: requestId, blockId } },
    body: { updateRequest, updateRequestStep },
  })
  throwIfApiError(error)
}

export const useUpdateRequestConfig = () => {
  const { getToken } = useAuthenticatedUser()

  return useMutation({
    mutationFn: async (params: UpdateRequestConfigParams) => {
      const token = await getToken()
      await callUpdateBlockConfigApi(token, params)
    },
  })
}
